// Find all classes with a name ending with Model  
export class ExchangeTokenRequest {
    public userId: string;
    public accessToken: string;
    public refreshToken: string
}  
